import { AppStateEnum } from '../../../main/types/app-state.types.ts';

import { CharacterBubbleAnimation } from '../../constants/character-bubble-animations.ts';

export const APP_STATE_SLICE_NAME = 'appState';

export interface AppStateSliceState {
  state: AppStateEnum;
  isBlockingAnimation: boolean;
  isAbortingStep: boolean;
  isSpeaking: boolean;
  currentUpdateTimeoutId: NodeJS.Timeout | null;
  currentCharacterBubbleAnimation: CharacterBubbleAnimation | null;
}
